import { HomeViewType } from '@/core/presenter/viewModel/viewTypes';
import HomeHeader from './HomeHeader';
import HomeTab from './HomeTab';
import MyAssetsCard from './MyAssetsCard';
import * as ViewModel from '@/core/presenter/viewModel';

interface IProps {
  totalBalance: string;
  trxAddress: string;
  activities: ViewModel.IResponseActivity[];
  isNotActivities: boolean;
  trxAsset?: ViewModel.IAsset;
  tokenAsset?: ViewModel.IAsset;
  trxBalance: string;
  tokenBalance: string;
  trxKrw: string;
  tokenKrw: string;
  activeTab: ViewModel.HomeTabType;
  isSendingAsset: boolean;
  dbsBuyCount: string;
  dbsBuyCountKRW: string;
  trxPrice: number;
  tokenPrice: number;
  onClickActiveTab: (tab: ViewModel.HomeTabType) => void;
  onClickCopyBtn: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onClickResetBtn: () => void;
  onClickViewType: (viewType: HomeViewType) => void;
  onClickSendBtn: () => void;
  onClickPrevTransactionBtn: () => void;
}

const MainView = ({
  totalBalance,
  trxAddress,
  activities,
  isNotActivities,
  trxAsset,
  tokenAsset,
  trxBalance,
  tokenBalance,
  trxKrw,
  tokenKrw,
  activeTab,
  isSendingAsset,
  dbsBuyCount,
  dbsBuyCountKRW,
  trxPrice,
  tokenPrice,
  onClickActiveTab,
  onClickCopyBtn,
  onClickResetBtn,
  onClickViewType,
  onClickSendBtn,
  onClickPrevTransactionBtn,
}: IProps) => {
  return (
    <div className="container">
      <HomeHeader />
      <MyAssetsCard
        totalBalance={totalBalance}
        trxAddress={trxAddress}
        isSendingAsset={isSendingAsset}
        dbsBuyCount={dbsBuyCount}
        dbsBuyCountKRW={dbsBuyCountKRW}
        onClickCopyBtn={onClickCopyBtn}
        onClickResetBtn={onClickResetBtn}
        onClickSendBtn={onClickSendBtn}
        onClickViewType={onClickViewType}
      />
      <HomeTab
        trxKrw={trxKrw}
        tokenKrw={tokenKrw}
        trxBalance={trxBalance}
        tokenBalance={tokenBalance}
        trxAsset={trxAsset}
        tokenAsset={tokenAsset}
        activities={activities}
        isNotActivities={isNotActivities}
        activeTab={activeTab}
        trxPrice={trxPrice}
        tokenPrice={tokenPrice}
        onClickViewType={onClickViewType}
        onClickActiveTab={onClickActiveTab}
        onClickPrevTransactionBtn={onClickPrevTransactionBtn}
      />
    </div>
  );
};

export default MainView;
